import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CognitoAuth, CognitoAuthOptions, CognitoAuthSession } from 'amazon-cognito-auth-js';

@Injectable()
export class Auth {
  private session: CognitoAuthSession | null = null;
    private readonly cognitoAuth: CognitoAuth | null = null;

  public callbackFn: null | ((token: string | null, err?: any) => void) = null;


  public static _REGION = environment.region;

  public static _IDENTITY_POOL_ID = environment.identityPoolId;
  public static _USER_POOL_ID = environment.userPoolId;
  public static _CLIENT_ID = environment.clientId;
  public static _DOMAIN = environment.domain;


  constructor() {
    // init cognito and prepare callbacks
    const authData: CognitoAuthOptions = {
      ClientId: `${process.env.APP_AWS_COGNITO_CLIENT_ID}`,
      AppWebDomain: `${process.env.APP_AWS_COGNITO_APP_WEB_DOMAIN}`,
      TokenScopesArray: ['email', 'profile', 'openid'],
      RedirectUriSignIn: `${process.env.UIsUrl}`,
      RedirectUriSignOut: `${process.env.UIsUrl}`,
      UserPoolId: `${process.env.APP_AWS_COGNITO_USER_POOL_ID}`,
    };
    this.cognitoAuth = new CognitoAuth(authData);
    this.cognitoAuth.userhandler = {
      onSuccess: (authSession: CognitoAuthSession) => {
        this.session = authSession;

        const accessToken = this.getAccessToken();
        if (this.callbackFn) {
          this.callbackFn(accessToken || null);
        }
      },
      onFailure: (err: any) => {
        console.log('Auth Error', err);
        if (this.callbackFn) {
          this.callbackFn(null, err);
        }
      },
    };

    // check if a new token is the url, and parse it
    const curUrl = window.location.href;
    if (curUrl.indexOf('#access_token=') >= 0) {
      this.cognitoAuth.parseCognitoWebResponse(curUrl);
      const pathBeforeSignIn = localStorage.getItem('pathBeforeSignIn') || '/';
      window.location.replace(pathBeforeSignIn);
    }
  }

  getIdToken = () => {
    return !!this.session && this.session.getIdToken().getJwtToken();
  };

  getIdTokenObj = () => {
    const idToken = this.getIdToken();
    return idToken && JSON.parse(atob(idToken.split('.')[1]));
  };

  getAccessToken = () => {
    return !!this.session && this.session.getAccessToken().getJwtToken();
  };

  getAccessTokenObj = () => {
    const accessToken = this.getAccessToken();
    return accessToken && JSON.parse(atob(accessToken.split('.')[1]));
  };

  // Use this method to login and/or refresh a session
  // Returns a promise with the existing or refreshed session token
  signIn = () => {
    // a login is in progress, do not trigger another one
    const curUrl = window.location.href;
    if (curUrl.indexOf('#access_token=') >= 0 || curUrl.indexOf('code=') >= 0) {
      return;
    }

    localStorage.setItem('pathBeforeSignIn', window.location.pathname || '/');
    if (!this.cognitoAuth) {
      return Promise.reject(null);
    }

    // prepare the return promise setting the global callback function
    // that will resolve/reject it
    const tokenPromise = new Promise<string>((resolve, reject) => {
      this.callbackFn = (token, err = null) => {
        if (err) {
          reject(err);
          return;
        }

        if (token && token.length > 0) {
          resolve(token);
          return;
        }

        reject('Token is empty');
      };
    });

    this.cognitoAuth.getSession();

    return tokenPromise;
  };

  signOut = () => {
    if (!this.cognitoAuth) {
      return;
    }
    this.cognitoAuth.signOut();
  };

  currentUser = () => {
    if (!this.cognitoAuth) {
      return;
    }
    return this.cognitoAuth.getCurrentUser();
  };
}
// export const Auth = new _Auth();


// WEBPACK FOOTER //
// ./src/app/shared/services/auth.service.ts